import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

const el = document.getElementById('SDT');
const locale = el.getAttribute('data-locale');
const productKey = el.getAttribute('data-productkey');
const context = el.getAttribute('data-context');
const dataCountry = el.getAttribute('data-country');
const dataScope = el.getAttribute('data-scope');

if (typeof(window.dataLayer) !== 'undefined') {
    // console.log('dataLayer defined');
    var dataLayer = window.dataLayer;
    // console.log(dataLayer);
}


document.addEventListener("DOMContentLoaded", function() {
    var domaineCssLink;
    if (context === 'int' || context === 'qual') {
        domaineCssLink = 'https://support-decision-tool.bostik.'+ context +'.eurelis.info/sites/default/files/sdt/static/css/main.css';
    } else if (context === 'prod-test'){
        domaineCssLink = 'support-decision-tool.bostik.prod.eurelis.info/sites/default/files/sdt/static/css/main.css';
    } else {
        domaineCssLink = 'https://back.product-selector.bostik/sites/default/files/sdt/static/css/main.css';
    }
    var link = document.createElement('link');
    link.id = 'styleadded';
    link.rel = 'stylesheet';
    link.href = domaineCssLink;
    // document.head.appendChild(link);
});


ReactDOM.render(<App locale={locale || ""} dataCountry={dataCountry || "UK"} dataScope={dataScope || "range"} context={context || "int"} productKey={productKey || "fire_rated_au"} dataLayer={dataLayer || null} />, el);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
